export default "__VITE_ASSET__B8CHa6JL__"